import React from 'react';
import colline from '../assets/colline.png';
import Footer from '../components/Footer';
import Box from '../components/Box';
import MyText from '../components/MyText';
import Trees from '../components/Trees';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';

export default function Ringraziamento(){
    const {t} = useTranslation();
    const isNotMobile = useMediaQuery({ query: '(min-width: 769px)' });
    return(
        <div style={{...styles.container,
            backgroundImage: `url(${colline})`,
            backgroundSize: 'cover',
            backgroundPosition: 'bottom',
        }}>
            <Footer />
                <Box style={{width: '80%', maxWidth: '100%'}}>
                    <div style={styles.boxContent}>
                        {isNotMobile && <div style={styles.blankSpace}/>}
                        <div style={styles.textContent}>
                            <MyText size={'3rem'} style={styles.title}>{t('ringraziamento_boxLine1')}</MyText>
                            <MyText size={'2rem'} style={styles.text}>{t('ringraziamento_boxLine2')}</MyText>
                        </div>
                        {isNotMobile && <Trees/>}
                    </div>
                </Box>
        </div>
    );
};
const styles = {
    container:{
        width: '100%',
        height: '100vh',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    content:{
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        // height: '100%',
    },
    boxContent:{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        gap: 8,
        padding:'32px 16px',
    },
    textContent:{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        gap: 16
    },
    title:{
        textAlign: 'center',
        fontWeight: 'bold',
        fontSize: 'clamp(16px, 10vw, 4rem)'
    },
    text:{
        textAlign: 'center',
        fontSize: 'clamp(12px, 10vw, 2rem)'
    },
    blankSpace:{
        width: '20%',
    },
}